// server domain
// export const MAIN_DOMAIN = `http://taxipoint-backend.dgcars.cloud/backend-taxipoint/public` //dev url

// export const MAIN_DOMAIN = `http://taxipoint.test` //local url
// export const WEB_SERVER_HOST = window.location.hostname + ':6001' //local url

// Light-taxipoint server configuration
// export const MAIN_DOMAIN = `https://api.light-taxipoint.com` // light-taxipoint server url
// export const WEB_SERVER_HOST = `https://socket.light-taxipoint.com:6001` // light-taxipoint socket url

// export const MAIN_DOMAIN = `https://api.taxipoint-backend.dgcars.cloud` //dev ssl url
// export const WEB_SERVER_HOST = `https://taxipoint-backend.dgcars.cloud:6001` //dev url


 export const MAIN_DOMAIN = `https://api.taxipoint.app` // prod url
 export const WEB_SERVER_HOST = `https://socket-api.taxipoint.app`// prod url

export const API = `${MAIN_DOMAIN}/api/V1`

